import { Components } from "@thisgorilla/primate-ds";
import { Fragment } from "react";
import { useTheme } from "styled-components";
import { Divider } from "../../../../../../../commonStyles";
import { useAppSelector } from "../../../../../../../redux";
import { FlexColumn } from "../../../../../../Common/Styles";
import { DraftsModalProps } from "../DraftsModal";
import DraftItem from "./draftItem";
import EmptyDraft from "./EmptyDraft";
import {
  FooterContainer,
  HeaderContainer,
  ListContainer,
  TabContainer,
} from "./style";

const tabItems = [
  { title: "Drafts" },
  { title: "Scheduled" },
  { title: "Published" },
];

const DraftModalContent = ({
  selectedTabIndex,
  setSelectedTabIndex,
  setIsDraftModalOpen,
  setDeliveryDate,
  setSchedulePostOpen,
  setSchedulePostId,
}: DraftsModalProps.DraftModalContentProps) => {
  const { typography } = useTheme();
  const { draftArticleList, publishedArticleList, scheduledArticleList } =
    useAppSelector((state) => state.article);
  const list = {
    0: draftArticleList,
    1: scheduledArticleList,
    2: publishedArticleList,
  };

  return (
    <>
      <HeaderContainer>
        <Components.Text
          text="Articles"
          style={{ tokenStyle: typography.Heading.S }}
          fontWeight="font-weight-semibold"
        />
      </HeaderContainer>
      <Divider />
      <TabContainer $selectedTabIndex={selectedTabIndex}>
        <Components.Tabs
          TabItems={tabItems}
          selectedTabIndex={selectedTabIndex}
          setSelectedTabIndex={setSelectedTabIndex}
        />
      </TabContainer>
      <Divider />
      {list[selectedTabIndex as keyof typeof list].length === 0 ? (
        <EmptyDraft title={`No ${tabItems[selectedTabIndex].title} yet.`} />
      ) : (
        <ListContainer>
          <FlexColumn $gapInPx={0}>
            {list[selectedTabIndex as keyof typeof list].map(
              ({ title, delivery_date, post_updated_at, id }, index) => {
                return (
                  <Fragment key={index}>
                    <DraftItem
                      title={title.content_data.Blueprint}
                      date={
                        new Date(
                          selectedTabIndex ? delivery_date : post_updated_at
                        )
                      }
                      post_id={id}
                      selectedTabIndex={selectedTabIndex}
                      setDeliveryDate={setDeliveryDate}
                      setSchedulePostOpen={setSchedulePostOpen}
                      setSchedulePostId={setSchedulePostId}
                    />
                    {index <
                      list[selectedTabIndex as keyof typeof list].length -
                        1 && <Divider />}
                  </Fragment>
                );
              }
            )}
          </FlexColumn>
        </ListContainer>
      )}
      <Divider />
      <FooterContainer>
        <Components.Button
          color="Neutral"
          kind="Primary"
          label="Close"
          disabled={false}
          onClick={() => setIsDraftModalOpen(false)}
          size="Medium"
        />
      </FooterContainer>
    </>
  );
};

export default DraftModalContent;
